import { isEmptyVal } from '@/utils';
import { checkMRSChange } from '@/utils/validator';
import { translation } from '@/plugins/i18n';
import { MRS_STATUS_TYPE_MAP, planTypes } from '@/common/constants';
import { dateTimeFormat } from '@/utils/dateformat.js';
import _, { get } from 'lodash';
import store from '@/store/index';
import { $context } from '@/global-install';

const PLAN_TYPES_LICENSE_UNIT = [
  planTypes.CONCURRENCY_MEETING_BASIC,
  planTypes.CONCURRENT_MEETING_PLUS,
  planTypes.TRANSLATION_CAPTIONS
];

const DOWNSELL_MSG_MAP = {
  user: {
    with_date: 'billing.error.downgrade_alert_info',
    without_date: 'billing.error.downgrade_alert_info_no_date'
  },
  license: {
    with_date: 'billing.error.downgrade_alert_info_license',
    without_date: 'billing.error.downgrade_alert_info_no_date_license'
  },
  plan_change: {
    with_date: 'billing.error.downgrade_alert_info_in_plan_change',
    without_date: 'billing.error.downgrade_alert_info_no_date'
  },
  workspaceReservationLicense: {  // workspace reservation use special notice
    with_date: 'billing.error.downgrade_alert_info_workspace_reservation_change'
  }
};

export const getDownSellLicenseDesc = ({oldPlan, nextPlan, quantity, assignLicenseQuantity, planExpireTime}) => {
  const getters = store.getters;
  const defaultResult = { errorState: 'info', errorMessage: '' };
  if (getters.basicConfig.isBulkLicenseAccount) {
    return defaultResult;
  }

  if (!isEmptyVal(quantity) && quantity < assignLicenseQuantity) {
    const needAssignQuantity = assignLicenseQuantity - quantity;
    const mrsResult = checkMRSChange({
      oldPlan,
      nextPlan,
      nextPlanQuantity: quantity,
    });

    if (mrsResult === MRS_STATUS_TYPE_MAP.CHANGE_NOW) {
      return defaultResult;
    }

    const wordingI18nMap = $context.is.zs2ze ? DOWNSELL_MSG_MAP.plan_change : PLAN_TYPES_LICENSE_UNIT.includes(oldPlan.type) ? DOWNSELL_MSG_MAP.license : DOWNSELL_MSG_MAP.user;
    let errorMessage = planExpireTime
    ? translation(wordingI18nMap.with_date, [needAssignQuantity, dateTimeFormat(planExpireTime)])
    : translation(wordingI18nMap.without_date, [needAssignQuantity]);
    if(nextPlan?.type === planTypes.WORKSPACE_RESERVATION) {
      errorMessage = translation(DOWNSELL_MSG_MAP.workspaceReservationLicense.with_date, {
        assignedCount: assignLicenseQuantity,
        needAssignQuantity,
        link: "/workspaces/management",
        expiredDate: dateTimeFormat(planExpireTime)
      })
    }
    return {
      assignLicenseQuantity,
      needAssignQuantity,
      planExpireTime,
      errorState: 'info',
      errorMessage
    };
  }

  return defaultResult;
};

export const getDownSellExpireTime = (planExpireTime) => {
  const getters = store.getters;
  let effectiveTime = planExpireTime;
  if (getters.shouldUseTermEndDate) {
    const termEndDate = dateTimeFormat(getters.basicConfig?.termEndDate);
    if (getters.basicConfig?.evergreen === true && planExpireTime && termEndDate) {
      effectiveTime = _.sortBy([planExpireTime, termEndDate], d => new Date(d))[0];
    } else {
      effectiveTime = termEndDate;
    }
  }
  return effectiveTime
}

export const validDownSellLicense = (planInfo = {}) => {
  const getters = store.getters;
  const { quantity = 0 } = planInfo;
  const { assignLicenseQuantity = 0, planExpireTime } = get(getters.assignInfo, getters.oldPlanCode, {});

  return getDownSellLicenseDesc({
    oldPlan: getters.currentEditPlan,
    nextPlan: get(getters.getSelectedPlans, '[0]', {}),
    quantity,
    assignLicenseQuantity,
    planExpireTime: getDownSellExpireTime(planExpireTime),
  });
};

export const validDownSellLicenseForBizPlus = (planInfo = {}) => {
  const getters = store.getters;
  const { quantity = 0, planCode } = planInfo;
  const { assignLicenseQuantity = 0, planExpireTime } = get(getters.assignInfo, planCode, {});
  const oldPlan = getters.boughtPlans.find(p => p.plan_code === planCode);
  const nextPlan = getters.getSelectedPlans.find(p => p.plan_code === planCode);
  return getDownSellLicenseDesc({
    oldPlan,
    nextPlan,
    quantity,
    assignLicenseQuantity,
    planExpireTime
  });
};

export const validDownSellLicenseForBiz2Pro = (quantity, oldPlan) => {
  const getters = store.getters
  const { assignLicenseQuantity = 0, planExpireTime } = get(getters.assignInfo, oldPlan.plan_code, {});
  return getDownSellLicenseDesc({
    oldPlan: oldPlan,
    nextPlan: find(getters.getSelectedPlans, (item) => item.type === planTypes.ZOOM_MEETING, {}),
    quantity,
    assignLicenseQuantity,
    planExpireTime: getDownSellExpireTime(planExpireTime),
  })
}


export const validDownSellLicenseForEdu2Esc = (planInfo = {}, oldPlan) => {
  const getters = store.getters;
  const { quantity = 0 } = planInfo;
  const { assignLicenseQuantity = 0, planExpireTime } = get(getters.assignInfo, oldPlan.plan_code, {});
  return getDownSellLicenseDesc({
    oldPlan: oldPlan,
    nextPlan: get(getters.getSelectedPlans, '[0]', {}),
    quantity,
    assignLicenseQuantity,
    planExpireTime: getDownSellExpireTime(planExpireTime),
  });
};
